/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { IS_PROD, PROJECT_VERSION } from 'helpers/config'
import {STORAGE_KEYS} from "constants/StorageKeys";
import {LocalStorage} from "utils/LocalStorage";

const clearStoreOnUpdate = (): void => {
    const APP_VERSION = PROJECT_VERSION;
    let savedVersion = LocalStorage.get<string>(STORAGE_KEYS.APP_VERSION);

    if (savedVersion === null) {
        LocalStorage.set(STORAGE_KEYS.APP_VERSION, APP_VERSION || "unknown");
        console.log("Local version not found, setting to: ", APP_VERSION);
        savedVersion = APP_VERSION || "unknown";
    }

    if (savedVersion !== APP_VERSION) {
        if (!IS_PROD) {
            console.log("Local current version: ", savedVersion, ", new version number: ", APP_VERSION);
        }
    }

    if (savedVersion && savedVersion !== "unknown" && savedVersion !== APP_VERSION) {
        LocalStorage.clear();

        if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(names => {
                for (const name of names) {
                    caches.delete(name);
                }
            });
        }

        // delete browser cache and hard reload
        window.location.reload();
    }
};
export default clearStoreOnUpdate;
